import { useState } from 'react'

import { getExtraProperty } from '@tribeplatform/gql-client/lib'
import { useSlateKitContext } from '@tribeplatform/react-slate-kit/hooks'
import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { Link } from '@tribeplatform/react-ui-kit/Link'

import { useCookieConsent } from '../../Apps/CookieConsent/CookieConsentProvider.js'
import { CookieConsentPreferencesModal } from '../../Apps/index.js'
import { T } from '../../i18n/components/T.js'

export const SidebarFooter = () => {
  const slateKitProps = useSlateKitContext()
  const {
    context: {
      networkExtraProperties,
      networkTermsOfServiceUrl,
      networkPrivacyPolicyUrl,
    },
  } = slateKitProps
  const { isCookieAppInstalled } = useCookieConsent()

  const currentYear = new Date().getFullYear()
  const termsOfServiceUrl =
    getExtraProperty(networkExtraProperties, 'termsOfServiceUrl') ??
    networkTermsOfServiceUrl

  const privacyPolicyUrl =
    getExtraProperty(networkExtraProperties, 'privacyPolicyUrl') ??
    networkPrivacyPolicyUrl

  const [isCookieModalOpen, setIsCookieModalOpen] = useState(false)

  return (
    <Container
      size="sm"
      spacing="xs"
      padding={{
        disableOnMobile: true,
        top: 'none',
        vertical: 'md',
        horizontal: 'sm',
      }}
      maxSize="sm"
    >
      <div className="flex flex-wrap space-s-1 text-xs text-content-on-background-subdued">
        {!!(termsOfServiceUrl || privacyPolicyUrl) && (
          <>
            {!!termsOfServiceUrl && (
              <Link variant="neutral" href={termsOfServiceUrl}>
                <T
                  id="SidebarFooter.TermsOfServiceLinkLabel"
                  defaultMessage="Terms"
                />
              </Link>
            )}

            {/* eslint-disable-next-line react/jsx-no-literals */}
            {!!termsOfServiceUrl && !!privacyPolicyUrl && <span> · </span>}

            {!!privacyPolicyUrl && (
              <Link variant="neutral" href={privacyPolicyUrl}>
                <T
                  id="SidebarFooter.PrivacyLinkLabel"
                  defaultMessage="Privacy"
                />
              </Link>
            )}
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <span> · </span>
          </>
        )}
        {isCookieAppInstalled && (
          <>
            <Link
              as="button"
              variant="neutral"
              onClick={() => setIsCookieModalOpen(true)}
            >
              <T
                id="SidebarFooter.CookiesButtonLabel"
                defaultMessage="Cookies"
              />
            </Link>
            {/* eslint-disable-next-line react/jsx-no-literals */}
            <span> · </span>
          </>
        )}
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <span aria-label="Copyright">© Copyright {currentYear}</span>
      </div>
      {isCookieModalOpen && (
        <CookieConsentPreferencesModal
          isOpen
          onClose={() => setIsCookieModalOpen(false)}
        />
      )}
    </Container>
  )
}
